define.alias("shared/components/shared/ui/report/industry-comparison", "calendar/components/shared/ui/report/industry-comparison");